import Radium from "radium";
import React from "react";

import { Remo } from "@components";
import { styles } from "@common/styles";
import { IApiKey } from "@common/models";
import ApiKeyItem from "./api-keys-item";
import ApiKeyModal from "./api-key.modal";

export interface IApiKeysProps {
  apiKeys: IApiKey[];
  buttonIsDisabled: boolean;
  userId: string;
}

export interface IApiKeysActions {
  refreshApiKeys: () => void;
  changeApiKeyName: (apiKey: IApiKey, newName: string) => void;
  createNewApiKey: (userId: string) => void;
  deleteApiKey: (userId: string, apiKeyName: string) => void;
}
export interface IApiKeysState {
  apiKey: IApiKey;
}

class ApiKeys extends React.Component<
  IApiKeysProps & IApiKeysActions,
  IApiKeysState
> {
  constructor(props) {
    super(props);

    this.state = {
      apiKey: null
    };
  }

  componentDidMount() {
    this.props.refreshApiKeys();
  }

  public render() {
    const { apiKeys, buttonIsDisabled, userId } = this.props;

    const lastListItem = {
      ...styles.listItem,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const buttonStyle = buttonIsDisabled ? {
      ...styles.okButton,
      backgroundColor: "#eee",
      cursor: "not-allowed"
    } : styles.okButton;

    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <div
          className="pageHeaderContainer"
          style={styles.pageHeaderContainer as any}
        >
          Håndter dine API-nøkler
        </div>
        <div
          className="contentContainer"
          style={styles.contentContainer as any}
        >
          <div style={{marginBottom: "10px"}}>
            <div style={styles.headerRow as any} className="headerRow">
              <div style={styles.listItem as any}>API-nøkkel</div>
              <div style={styles.listItem as any}>Token</div>
              <div style={lastListItem as any} />
            </div>
            {apiKeys && apiKeys.length > 0 ? (
              apiKeys.map((item, index) => (
                <ApiKeyItem
                  apiKey={item}
                  editApiKey={this.editApiKey}
                  key={index}
                />
              ))
            ) : (
              <div style={styles.noData as any} className="noData">
                Ingen API-nøkler
              </div>
            )}
          </div>
          <div style={styles.sendButtonContainer as any}>
            {

            }
            <button disabled={buttonIsDisabled} onClick={() => this.props.createNewApiKey(userId)} style={buttonStyle as any} title={buttonIsDisabled ? "Maks antall nøkler er opprettet." : ""}>
              Ny API-nøkkel
            </button>
          </div>
        </div>
        <Remo show={!!this.state.apiKey}>
          <ApiKeyModal
            apiKey={this.state.apiKey}
            cancel={this.closeModal}
            changeName={this.changeApiKeyName}
            delete={(apiKeyName) => {this.props.deleteApiKey(userId, apiKeyName); this.closeModal();}}
          />
        </Remo>
      </div>
    );
  }

  private changeApiKeyName = (name: string) => {
    const apiKey = this.state.apiKey;
    this.setState({ apiKey: null }, () =>
      this.props.changeApiKeyName(apiKey, name)
    );
  };

  private editApiKey = (apiKey: IApiKey) => {
    this.setState({ apiKey });
  };

  private closeModal = () => {
    this.setState({ apiKey: null });
  };
}

export default Radium(ApiKeys);
